export const serviceOperationStoreSlice = (set) => ({
  // ── Admin ────────────────────────────────────────────────────────────────
  soAdminSearch: {
    searchTerm: "",
    startDate: null,
    endDate: null,
  },
  soAdminPaginationModel: {
    page: 0,
    pageSize: 50,
  },
  soAdminSelectedStatus: null,
  soAdminSelectedStatusToExport: null,

  setSoAdminSearch: (value) =>
    set((state) => ({
      soAdminSearch:
        typeof value === "function" ? value(state.soAdminSearch) : value,
    })),
  setSoAdminPaginationModel: (value) => set({ soAdminPaginationModel: value }),
  setSoAdminSelectedStatus: (value) => set({ soAdminSelectedStatus: value }),
  setSoAdminSelectedStatusToExport: (value) =>
    set({ soAdminSelectedStatusToExport: value }),

  // ── Taller ───────────────────────────────────────────────────────────────
  soTallerSearch: {
    searchTerm: "",
    startDate: null,
    endDate: null,
  },
  soTallerPaginationModel: {
    page: 0,
    pageSize: 50,
  },
  soTallerSelectedStatus: null,

  setSoTallerSearch: (value) =>
    set((state) => ({
      soTallerSearch:
        typeof value === "function" ? value(state.soTallerSearch) : value,
    })),
  setSoTallerPaginationModel: (value) =>
    set({ soTallerPaginationModel: value }),
  setSoTallerSelectedStatus: (value) => set({ soTallerSelectedStatus: value }),
  clearSoTallerSearch: () =>
    set({ soTallerSearch: { searchTerm: "", startDate: null, endDate: null } }),
  clearSoTallerPaginationModel: () =>
    set({ soTallerPaginationModel: { page: 0, pageSize: 50 } }),
  clearSoTallerSelectedStatus: () => set({ soTallerSelectedStatus: null }),
  clearSoTallerFilters: () =>
    set({
      soTallerSearch: { searchTerm: "", startDate: null, endDate: null },
      soTallerPaginationModel: { page: 0, pageSize: 50 },
    }),

  // ── Panel Admin ──────────────────────────────────────────────────────────
  soPanelActiveTab: 0,
  setSoPanelActiveTab: (value) => set({ soPanelActiveTab: value }),
});
